const pathNames = {
    default: "/",
    margin: "/margin",
    exchange: "/exchange",
    fees: "/fees",
    positions_and_history: "/positions-and-history",
    lending: "/lending",
    referral_overview: "/referral-overview",
};
export default pathNames;